import React, { useEffect, useState } from "react";
import ConfirmForm from "./ConfirmForm";
import OnScrollAnimationWrapper from "../common/OnScrollAnimationWrapper";

function ConfirmationContainer({ t }) {
  const [guests, setGuests] = useState(0);

  useEffect(() => {}, [guests]);

  return (
    <section
      className="confirmation-container bg-beige p-top-8 p-bottom-8"
      id="confirm"
    >
      <div className="container">
        <h2 className="text-primary text-center font-body">{t.confirmPresenceTitle}</h2>
        <div className="text-primary text-center m-top-2 m-bottom-6 text-lg">
          {t.confirmByFull} <span className="deadline-text">{" "}{t.deadline}</span>
        </div>
        <ConfirmForm t={t} />
        <OnScrollAnimationWrapper
          animation={"animation-slide-fade-in-down"}
          triggerOnce={false}
          classNameInitialState={`opacity-0 text-animation-slide-in`}
        >
          <h4 className="text-primary text-center m-top-4 m-bottom-4 font-body">
            {t.confirmForAnotherGuest}
          </h4>
        </OnScrollAnimationWrapper>

        {guests > 0 &&
          [...Array(guests)].map((item, index) => {
            return (
              <div key={index} className="m-top-3 m-bottom-3">
                <ConfirmForm t={t} />
              </div>
            );
          })}

        <div className="m-top-4 m-bottom-2 text-center">
          <button
            className="confirm-btn confirm-btn-inverse"
            onClick={() => setGuests(guests + 1)}
          >
            {t.addGuest}
          </button>
        </div>
      </div>
    </section>
  );
}

export default ConfirmationContainer;
